// Stub for makeUrl
export default function resourceUrl(url) {
    if (!url) return '';
    // If URL starts with /, it's already a path
    if (url.startsWith('/')) return url;
    // Otherwise return as-is
    return url;
}
